import React from 'react';

function FavouriteFilled() {
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18.5587 4.36056C20.6322 6.43956 20.7037 9.75056 18.775 11.9102L11.0017 19.6946L3.23019 11.9102C1.30153 9.75056 1.37394 6.43406 3.44653 4.36056C5.52278 2.28523 8.84386 2.21557 11.0035 4.15156C13.1568 2.21831 16.4843 2.28248 18.5587 4.36056Z"
        fill="#EE3A43"
      />
    </svg>
  );
}

export default FavouriteFilled;
